import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';

function CollectionPage() {
  const { slug } = useParams();
  const [collection, setCollection] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/api/collections/${slug}`)
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          setCollection(d.data.collection);
          setItems(d.data.items || []);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888' }}>Loading...</div>;
  if (!collection) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888' }}>Collection not found</div>;

  const imageField = collection.fields?.find(f => f.type === 'image');
  const titleField = collection.fields?.find(f => f.type === 'text') || collection.fields?.[0];

  return (
    <>
      <main style={{ paddingTop: 100, paddingBottom: 60, minHeight: '100vh', background: 'var(--color-bg-dark)' }}>
        <div className="container">
          <div className="section__header" style={{ textAlign: 'center', marginBottom: 48 }}>
            <h1 className="section__title">{collection.name}</h1>
            {collection.description && <p className="section__subtitle">{collection.description}</p>}
            <div className="divider" />
          </div>

          {items.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#888' }}>No items yet.</p>
          ) : (
            <div style={{
              display: 'grid',
              gridTemplateColumns: collection.displayLayout === 'list' ? '1fr' : 'repeat(auto-fill, minmax(300px, 1fr))',
              gap: 24,
            }}>
              {items.map((item, idx) => (
                <motion.div
                  key={item._id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: idx * 0.05 }}
                  style={{
                    background: 'var(--color-bg-card)',
                    borderRadius: 'var(--radius-md, 12px)',
                    overflow: 'hidden',
                    border: '1px solid rgba(255,255,255,0.05)',
                  }}
                >
                  {imageField && item.data?.[imageField.name] && (
                    <img
                      src={item.data[imageField.name]}
                      alt={titleField ? item.data[titleField.name] : ''}
                      style={{ width: '100%', height: 200, objectFit: 'cover' }}
                    />
                  )}
                  <div style={{ padding: 20 }}>
                    {collection.fields?.filter(f => f.type !== 'image').map(field => {
                      const val = item.data?.[field.name];
                      if (!val && val !== 0) return null;
                      if (field.type === 'boolean') return null;
                      return (
                        <div key={field.name} style={{ marginBottom: 8 }}>
                          {field.name === titleField?.name ? (
                            <h3 style={{ color: '#fff', fontSize: 18, fontWeight: 600, margin: 0 }}>{val}</h3>
                          ) : field.type === 'url' ? (
                            <a href={val} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-primary)', fontSize: 14 }}>{val}</a>
                          ) : field.type === 'textarea' ? (
                            <p style={{ color: 'var(--color-text-muted)', fontSize: 14, lineHeight: 1.6, margin: 0 }}>{val}</p>
                          ) : field.type === 'number' ? (
                            <span style={{ color: 'var(--color-primary)', fontSize: 16, fontWeight: 600 }}>{val}</span>
                          ) : (
                            <p style={{ color: 'var(--color-text-muted)', fontSize: 14, margin: 0 }}>{val}</p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}

export default CollectionPage;
